<template>
  <div class='cvss-score-box' :style="cvssStyle">
    {{value}}
  </div>
</template>

<script>

import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'CvssScore',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    cvssStyle() {
      return {
        ...this.color,
        backgroundColor: hexToRgba(this.color.color, 0.1),
      };
    },
    color() {
      const severity = this.value;
      if (severity >= 9 && severity <= 10) {
        return {color: '#E0255E'};
      }
      if (severity >= 7 && severity <= 8.9) {
        return {color: '#FF7F00'};
      }
      if (severity >= 4 && severity <= 6.9) {
        return {color: '#2459d5'};
      }
      return {color: '#2BAF69'};
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.cvss-score-box {
  color: var(--text-secondary);
  background-color: rgba(169, 182, 195, 0.1);
  border-radius: $radius-md;
  text-transform: capitalize;
  align-items: center;
  display: flex;
  font-family: $font-family-semibold;
  font-size: $font-size-sm;
  letter-spacing: 0;
  line-height: rem(17);
  justify-content: center;
  padding: rem(2) rem(5);
  min-width: rem(65);
}
</style>
